import { render } from "./header.vue?vue&type=template&id=8c7bc1b0&scoped=true&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=8c7bc1b0&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=8c7bc1b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7bc1b0"]])

export default __exports__